<template>
  <div class="announce section-container">
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <div class="section-container-spacer text-center">
            <h1 class="h2">06 : 招标公示</h1>
          </div>
        </div>
      </div>
      <div class="row announce-content">
        <!-- 左侧列表 -->
        <div class="col-xs-12" :class="{ 'col-md-6': selectedItem }">
          <div class="announce-list">
            <div
              v-for="(item, index) in announceList"
              :key="index"
              class="announce-card"
              :class="{ active: selectedIndex === index }"
              @click="selectItem(index)"
            >
              <div class="card-header">
                <div class="card-title-row">
                  <h3>{{ item.projectName }}</h3>
                  <span class="card-tag">中标公告</span>
                </div>
              </div>
              <div class="card-body">
                <p class="card-info">
                  <span class="label">中标方：</span>
                  <span class="value">{{ item.winnerName }}</span>
                </p>
                <p class="card-info">
                  <span class="label">时间：</span>
                  <span class="value">{{ item.date }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- 右侧详情 -->
        <div v-if="selectedItem" class="col-xs-12 col-md-6 announce-detail">
          <div class="detail-container">
            <div class="detail-header">
              <h2>项目详情</h2>
              <button class="close-btn" @click="closeDetail" v-if="!isMobile">×</button>
            </div>
            <div class="detail-body">
              <div class="detail-item">
                <span class="detail-label">项目名称：</span>
                <span class="detail-value">{{ selectedItem.projectName }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">中标方名称：</span>
                <span class="detail-value">{{ selectedItem.winnerName }}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">时间：</span>
                <span class="detail-value">{{ selectedItem.date }}</span>
              </div>
              <div class="detail-actions">
                <button 
                  class="download-btn" 
                  :class="{ disabled: !selectedItem.image }"
                  @click="downloadFile"
                  :disabled="!selectedItem.image"
                >
                  {{ selectedItem.image ? '下载中标文件' : '已超过下载时效' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile } from '@/utils/index.js'

export default {
  name: 'Announce',
  components: {},
  props: {},
  computed: {
    selectedItem() {
      return this.selectedIndex !== null ? this.announceList[this.selectedIndex] : null
    }
  },
  data() {
    return {
      isMobile,
      selectedIndex: null,
      // 图片资源映射
      imageMap: {
        'announce-1.png': require('@/assets/images/announce/announce-1.png')
      },
      announceList: [
        {
          projectName: '成都诺朗科技有限公司城厢清泉敬老院监控服务项目',
          winnerName: '中国移动通信集团四川有限公司成都分公司',
          date: '2025年12月10日',
          image: 'announce-1.png'
        },
        {
          projectName: '成都诺朗科技有限公司无人机采购项目',
          winnerName: '大疆创新科技有限公司',
          date: '2025年7月15日'
        },
        {
          projectName: '成都诺朗科技有限公司养老机器人采购项目',
          winnerName: '优必选科技股份有限公司',
          date: '2025年3月20日'
        },
        {
          projectName: '成都诺朗科技有限公司工业物联网传感器采购项目',
          winnerName: '海康威视数字技术股份有限公司',
          date: '2024年11月8日'
        },
        {
          projectName: '成都诺朗科技有限公司智能产线设计服务采购项目',
          winnerName: '研华科技（中国）有限公司',
          date: '2024年6月25日'
        }
      ]
    }
  },
  watch: {},
  methods: {
    selectItem(index) {
      if (this.isMobile) {
        // 移动端：切换选中状态
        this.selectedIndex = this.selectedIndex === index ? null : index
      } else {
        // PC端：直接选中
        this.selectedIndex = index
      }
    },
    closeDetail() {
      this.selectedIndex = null
    },
    async downloadFile() {
      if (!this.selectedItem || !this.selectedItem.image) return
      
      try {
        // 从映射中获取图片资源
        const imageUrl = this.imageMap[this.selectedItem.image]
        if (!imageUrl) {
          console.error('找不到图片资源:', this.selectedItem.image)
          return
        }
        
        // 使用 fetch 获取图片并转换为 blob
        const response = await fetch(imageUrl)
        const blob = await response.blob()
        
        // 创建 blob URL
        const blobUrl = window.URL.createObjectURL(blob)
        
        // 创建下载链接
        const link = document.createElement('a')
        link.href = blobUrl
        link.download = `${this.selectedItem.projectName}.png`
        document.body.appendChild(link)
        link.click()
        
        // 清理
        document.body.removeChild(link)
        window.URL.revokeObjectURL(blobUrl)
      } catch (error) {
        console.error('下载文件失败:', error)
        // 降级方案：直接打开图片
        try {
          const imageUrl = this.imageMap[this.selectedItem.image]
          if (imageUrl) {
            window.open(imageUrl, '_blank')
          }
        } catch (e) {
          console.error('无法打开图片:', e)
        }
      }
    }
  },
  mounted() {}
}
</script>

<style lang="scss">
.announce {
  background: #fff;

  .announce-content {
    margin-top: 40px;
  }

  .announce-list {
    .announce-card {
      background: #fff;
      border: 1px solid #000;
      margin-bottom: 20px;
      padding: 20px;
      cursor: pointer;
      transition: all 0.3s ease;
      position: relative;

      &:hover {
        background: #f5f5f5;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }

      &.active {
        background: #000;
        color: #fff;
        border-color: #000;

        .card-header h3,
        .card-info .label,
        .card-info .value {
          color: #fff;
        }
      }

      .card-header {
        margin-bottom: 15px;

        .card-title-row {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          gap: 15px;
        }

        h3 {
          color: #000;
          font-size: 18px;
          font-weight: 600;
          margin: 0;
          line-height: 1.5;
          flex: 1;
        }

        .card-tag {
          display: inline-block;
          padding: 4px 12px;
          background: #000;
          color: #fff;
          font-size: 12px;
          font-weight: 500;
          white-space: nowrap;
          flex-shrink: 0;
        }
      }

      &.active {
        .card-header .card-tag {
          background: #fff;
          color: #000;
        }
      }

      .card-body {
        .card-info {
          margin: 8px 0;
          font-size: 14px;
          line-height: 1.6;

          .label {
            color: #666;
            font-weight: 500;
          }

          .value {
            color: #000;
          }
        }
      }

      &.active {
        .card-info .label,
        .card-info .value {
          color: #fff;
        }
      }
    }
  }

  .announce-detail {
    padding-left: 30px;

    .detail-container {
      background: #fff;
      border: 1px solid #000;
      padding: 30px;
      position: sticky;
      top: 20px;

      .detail-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;
        padding-bottom: 15px;
        border-bottom: 1px solid #000;

        h2 {
          color: #000;
          font-size: 24px;
          font-weight: 600;
          margin: 0;
        }

        .close-btn {
          background: transparent;
          border: 1px solid #000;
          color: #000;
          width: 30px;
          height: 30px;
          font-size: 24px;
          line-height: 1;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;

          &:hover {
            background: #000;
            color: #fff;
          }
        }
      }

      .detail-body {
        .detail-item {
          margin-bottom: 25px;
          line-height: 1.8;

          .detail-label {
            color: #000;
            font-weight: 600;
            font-size: 16px;
            display: inline-block;
            min-width: 120px;
          }

          .detail-value {
            color: #000;
            font-size: 16px;
          }
        }

        .detail-actions {
          margin-top: 30px;
          padding-top: 20px;
          border-top: 1px solid #e0e0e0;

          .download-btn {
            background: #000;
            color: #fff;
            border: 1px solid #000;
            padding: 12px 24px;
            font-size: 16px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.3s ease;
            width: 100%;

            &:hover:not(.disabled):not(:disabled) {
              background: #fff;
              color: #000;
            }

            &:active:not(.disabled):not(:disabled) {
              transform: scale(0.98);
            }

            &.disabled,
            &:disabled {
              background: #e0e0e0;
              color: #999;
              border-color: #e0e0e0;
              cursor: not-allowed;
              opacity: 0.7;
            }
          }
        }
      }
    }
  }

  // 移动端样式
  @media (max-width: 768px) {
    .announce-content {
      margin-top: 20px;
    }

    .announce-list {
      .announce-card {
        padding: 15px;
        margin-bottom: 15px;

        .card-header {
          .card-title-row {
            flex-direction: column;
            align-items: flex-start;
            gap: 10px;
          }

          h3 {
            font-size: 16px;
          }

          .card-tag {
            font-size: 11px;
            padding: 3px 10px;
          }
        }

        .card-body .card-info {
          font-size: 13px;
        }
      }
    }

    .announce-detail {
      padding-left: 0;
      margin-top: 20px;

      .detail-container {
        position: relative;
        top: 0;
        padding: 20px;

        .detail-header {
          margin-bottom: 20px;
          padding-bottom: 10px;

          h2 {
            font-size: 20px;
          }
        }

        .detail-body {
          .detail-item {
            margin-bottom: 20px;

            .detail-label {
              font-size: 14px;
              min-width: 100px;
              display: block;
              margin-bottom: 5px;
            }

            .detail-value {
              font-size: 14px;
              display: block;
            }
          }

          .detail-actions {
            margin-top: 20px;
            padding-top: 15px;

            .download-btn {
              padding: 10px 20px;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
</style>

